import { Modal } from "components/Modal";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40rem;
  margin: 0 auto;
  padding: 4rem;
`;
